/**
 * Case-insensitive substring (contains) match. This is the shared matcher used
 * by the "Is Any Of" pick list filter (PickListFilter) and the Manage Columns
 * search (TableStateEditor) so both behave identically. An empty query matches
 * everything (`''.includes` is always true).
 */
export const matchSubstring = (label: string, query: string): boolean =>
  label.toLowerCase().includes(query.toLowerCase())
